import { identity } from 'lodash-es';
import { createSelector } from 'reselect';

const getBusinessProfileFormInitialValues = (businessProfile: any) => businessProfile;

const businessProfileFormInitialValuesSelector = createSelector(getBusinessProfileFormInitialValues, identity);

export default businessProfileFormInitialValuesSelector;
